import { Component, OnInit, ViewEncapsulation, Inject, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UtilityService } from '@irb/irb-common/services/utility.service';
import { AppService } from '@irb/app.service';
import { ISystemMessages, ISystemMessage } from '@irb/irb-dashboard/irb-dashboard.model';

export interface DialogAnnoucementConfig {
  systemMessage: ISystemMessage;
  onProceed: Function;
}

@Component({ standalone: false,
  selector: 'irb-dialog-announcements',
  templateUrl: './dialog-announcements.component.html',
  styleUrls: ['./dialog-announcements.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DialogAnnouncementsComponent implements OnInit {
  data: ISystemMessages;

  constructor(public dialogRef: MatDialogRef<DialogAnnouncementsComponent>, 
    @Inject(MAT_DIALOG_DATA) public mdd: DialogAnnoucementConfig, 
    public as: AppService,
    private util: UtilityService) {
      if(this.mdd) {
        const d = new Date(this.util.getEasternTime(new Date().getTime()));
        this.data = {
          systemMessages: [this.util.clone(this.mdd.systemMessage)],
          lastModified: this.util.formatDateTimeString(d, "MM/dd/yyyy hh:mm tt") + " ET"
        } as ISystemMessages;
      } else {
        this.data = this.as.getFromSession("systemMessages") as ISystemMessages;
      }
  }

  ngOnInit() {    
  }

  close() {
    this.dialogRef.close();
  }

  formatDate(n: any) {
    const d = typeof(n) === "number" ? new Date(this.util.getEasternTime(n)) : new Date(this.util.getEasternTime(new Date(n).getTime()));
    return this.util.formatDateTimeString(d, "MM/dd/yyyy hh:mm tt") + " ET";
  }
}
